/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputText from "components/ui/input/InputText";

/**
 * 建物名
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} maxLength 最大文字数
 * @param {String} txtCaption キャプション 注釈
 */
const BldNmKj = memo(({ required, maxLength, txtCaption }) => {

  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      <LabelWithOptionIcon required={required}>
        建物名
      </LabelWithOptionIcon>
      <InputText
        name="bldNmKj"
        placeholder="タテモノタワー"
        maxLength={maxLength}
        rules={{
          pattern: {
            value: /^[^ -~｡-ﾟ\t]*$/,
            message: "建物名は15文字以内の全角文字で入力してください。",
          },
        }}
      ></InputText>
      <p css={mtgCaption}>{txtCaption}</p>
    </div>
  );
});

export default BldNmKj;
